import React, { PureComponent } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';

// import components
import CtaBarModal from './CtaBarModal';

// import styled components
import { CtaBarButton, CtaBarButtonContainer, CtaBarContainer, CtaBarWrapper } from './styled';

// import assets
import { ReactComponent as OthlLogo } from '../../../assets/othl/othl-logo-white.svg';
import { ReactComponent as CellPhoneIcon } from '../../../assets/img/cell-phone-icon.svg';
import { ReactComponent as HeadsetPersonIcon } from '../../../assets/img/headset-person-icon.svg';

class CtaBar extends PureComponent {
  state = {
    modalAttr: {
      display: 'none',
      overflow: '',
      position: '',
    },
  };

  showModal = () => {
    document.body.classList.add('modal-open');

    const newModalAttr = { ...this.state.modalAttr };

    newModalAttr.display = 'flex';
    newModalAttr.overflow = 'hidden';
    newModalAttr.position = 'fixed';

    this.setState({
      modalAttr: newModalAttr,
    });
  };

  hideModal = () => {
    document.body.classList.remove('modal-open');

    const newModalAttr = { ...this.state.modalAttr };

    newModalAttr.display = 'none';

    this.setState({
      modalAttr: newModalAttr,
    });
  };

  render() {
    return (
      <>
        <CtaBarWrapper>
          <CtaBarContainer>
            <a
              href="https://onetrusthomeloans.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="OneTrustHomeLoans.com"
            >
              <OthlLogo />
            </a>
            <CtaBarButtonContainer>
              <CtaBarButton onClick={this.showModal}>
                <HeadsetPersonIcon />{' '}
                <span>
                  <strong>Request a Consultation</strong>
                </span>
              </CtaBarButton>
              {this.props.localCallNumber ? (
                <CtaBarButton>
                  <CellPhoneIcon className="cell" />
                  <a className="tel" href={`tel:${this.props.localCallNumber}`}>
                    <span>
                      <strong>Call Us</strong> {this.props.localCallNumber}
                    </span>
                  </a>
                </CtaBarButton>
              ) : null}
            </CtaBarButtonContainer>
            <AnchorLink href="#nav-header">Back to Top</AnchorLink>
          </CtaBarContainer>
        </CtaBarWrapper>
        <CtaBarModal
          attr={this.state.modalAttr}
          hideModal={this.hideModal}
          name={this.props.name}
          account={this.props.account}
        />
      </>
    );
  }
}

export default CtaBar;
